import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ChangeControlPinTask extends AbstractRequestTask {
  constructor(params = {}, version = 'v1') {
    super();
    this.ownParams = params;
    this.version = version;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;

    return Object.assign({}, params, { user_id, ...this.ownParams });
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'changecontrolpin';
    
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}

}

export default ChangeControlPinTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ChangeControlPinTask.js